import React, { useEffect, useState } from 'react'
import Header from '../../../common/header/Header'
import Kundli_Main_Banner from '../kundli_main_bannner/Kundli_Main_Banner'
import Kundli_Common_Section from '../kundli_common_section/Kundli_Common_Section'
import Home_Private_Confidential from '../../home_page_components/home_private_confidential/Home_Private_Confidential'
import Footer from '../../../common/footer/Footer'
import Similar_Daily_Horoscope from './Similar_Daily_Horoscope'
import { Get_Astrology_data, handle_fetch_master_data } from '../../../../api/global/Global'
import { useNavigate, useParams } from 'react-router-dom'
import Loader from '../../../../loader/Loader'
import { IMG_BASE_URL, WEB_DOMAIN_KEY } from '../../../../config/Config'
import parse from 'html-react-parser';
import { Helmet } from 'react-helmet'
import { toast } from 'react-toastify'

const Daily_Horoscope = () => {
    const [astrology_data, set_AstrologyData] = useState({});
    const [is_loading, set_Is_Loading] = useState(false)
    const navigate = useNavigate()
    const { slug } = useParams()

    useEffect(() => {
        const Handle_Get_Astrology_data = async () => {
            set_Is_Loading(true)
            try {
                const response = await Get_Astrology_data(slug);
                if (response?.data?.status == 200) {
                    set_AstrologyData(response?.data?.data?.astrology)
                }
                if (response?.response?.data?.status == 500) {
                    toast.error(response?.response?.data?.message)
                    navigate("/")
                    return;
                }
            } catch (error) {
                console.error("error", error)
            } finally {
                set_Is_Loading(false)
            }
        }
        if (slug) {  // make sure slug exists before calling
            Handle_Get_Astrology_data();
        }
    }, [slug])


    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <Helmet>
                <title>{astrology_data?.meta_title}</title>
                <meta name="description" content={astrology_data?.meta_description} />

                <link rel="canonical" href={`${WEB_DOMAIN_KEY}horoscope/${astrology_data?.slug}`} />
                <link rel="alternate" hreflang="en-us" href={`${WEB_DOMAIN_KEY}horoscope/${astrology_data?.slug}`} />

            </Helmet>
            <div>
                {
                    is_loading ? (
                        <Loader />
                    ) : (


                        <>
                            {/* <----------- Header section's -----------> */}
                            <Header />
                            {/* <--------- Kundli Main Banner section's ----------> */}
                            <Kundli_Main_Banner banner={{ banner: astrology_data?.banner, alt: astrology_data?.alt }} />
                            <section className="gi-category py-[40px] max-[767px]:p-[15px] bg-[#F0F4F8]">
                                <div
                                    className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                                    <div className="flex flex-wrap w-full">
                                        <div className="w-full min-[992px]:w-[50%] md:pr-8">
                                            <div className="kundliimg">
                                                <img src={`${IMG_BASE_URL}${astrology_data?.image}`} className="w-full" alt={astrology_data?.alt} />
                                            </div>

                                        </div>

                                        <div className="w-full min-[992px]:w-[50%]">

                                            <div className="kundli_info">
                                                <h1 className="text-2xl mb-2 font-semibold text-gray-900">{astrology_data?.title}</h1>
                                                <p className="text-gray-700 mb-4 sub__title">{astrology_data?.short_description
                                                    ? parse(String(astrology_data.short_description))
                                                    : ""}</p>


                                            </div>
                                        </div>
                                    </div>

                                    {/* <---------- Similar Daily Horoscope section's ----------> */}
                                    <Similar_Daily_Horoscope />

                                    <p className="text-gray-700 mt-6 sub__title">{astrology_data?.description
                                        ? parse(String(astrology_data.description))
                                        : ""}</p>

                                </div>
                            </section>

                            {/* <-------- Kundli Common section's -------------> */}
                            <Kundli_Common_Section />

                            {/* <-------- Kundli faq section's -------------> */}
                            {/* <Kundli_Faq /> */}

                            {/* <--------- Home_Private_Confidential -------------> */}
                            <Home_Private_Confidential />

                            {/* <-------------- Footer section's ------------> */}
                            <Footer />
                        </>
                    )
                }
            </div>
        </>
    )
}

export default Daily_Horoscope